<div class="overflow-hidden pt-2">
  <div class="flex flex-row-reverse">
    <button
      (click)="changeZoomValue('1')"
      [disabled]="currentStep >= countOfSteps"
    >+</button>
    <button
      (click)="changeZoomValue('-1')"
      [disabled]="currentStep <= 0"
    >-</button>
    <mat-form-field
      class="select-classic max-w-[100px] mr-2 text-center"
      appearance="outline"
    >
      <mat-select
        class="text-sm"
        (selectionChange)="changeZoomValue($event.value, true)"
        [value]="currentValue"
        panelClass="single-select-overlay"
      >
        @for (item of zoomValues; track item) {
          <mat-option [value]="item">{{ item }}%</mat-option>
        }
      </mat-select>
      <mat-icon
        class="arrow-down"
        matSuffix
      >keyboard_arrow_down</mat-icon>
    </mat-form-field>
  </div>
</div>
